import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";

const AccordionSummary: React.FC<AccordionSummaryProps> = MuiAccordionSummary;

export default AccordionSummary;
export type { AccordionSummaryProps };